import { gsap } from "gsap";
import { Container } from "pixi.js";

import { AbstractGameMode } from "../flow/AbstractGameMode";
import { AbstractNearWin } from "./AbstractNearWin";
import { AbstractSymbol } from "./AbstractSymbol";

export interface IReelData {
    hasNearWin?: boolean;
    hasScatter?: boolean;
    stopSymbolNames?: string[];
    firstScatterReelToStop?: boolean;
}

export class AbstractReel extends Container {
    protected currentSymbols: AbstractSymbol[];
    protected defaultPositions: number[];
    protected initialPositions: number[];
    protected initialSymbolsAsString: string[];
    protected scatterNearWin: AbstractNearWin;
    protected stopSymbols: AbstractSymbol[] = [];
    protected stopPositions: number[];
    protected symbolsContainer: Container;
    protected _gameMode: AbstractGameMode;

    protected normalReelSet: string[];
    protected fsReelSet: string[];

    public reelId: number;
    public isLocked: boolean = false;

    public set gameMode(value: AbstractGameMode) {
        if (this._gameMode === value) return;

        this._gameMode = value;

        this.onGameModeUpdate();
    }

    protected get reelSet(): string[] {
        return this._gameMode === AbstractGameMode.NORMAL ? this.normalReelSet : this.fsReelSet;
    }

    public get gameMode(): AbstractGameMode {
        return this._gameMode;
    }

    constructor(
        reelId: number,
        symbols: string[],
        gameMode: AbstractGameMode = AbstractGameMode.NORMAL
    ) {
        super();

        this.reelId = reelId;

        this.gameMode = gameMode;

        this.normalReelSet = [];
        this.fsReelSet = [];

        this.symbolsContainer = new Container();
        this.symbolsContainer.name = `SymbolsContainer`;
        this.addChild(this.symbolsContainer);

        this.generatePositions();
        this.generateInitialSymbols(symbols);

        this.initializeOtherGraphics();
    }

    protected generatePositions(): void {
        this.initialPositions = [];
        this.defaultPositions = [];
        this.stopPositions = [];
    }

    // eslint-disable-next-line no-unused-vars
    protected generateInitialSymbols(symbols: string[]): void {
        this.initialSymbolsAsString = symbols;
    }

    protected initializeOtherGraphics(): void {}

    protected onGameModeUpdate(): void {}

    // eslint-disable-next-line no-unused-vars
    public generateStopSymbols(newSymbols: string[]) {}

    public startNormalBetAnimation(): gsap.core.Timeline {
        return gsap.timeline();
    }

    public stopNormalBetAnimation(
        // eslint-disable-next-line no-unused-vars
        data: IReelData,
        // eslint-disable-next-line no-unused-vars
        onReelComplete?: Function | undefined
    ): gsap.core.Timeline {
        return gsap.timeline();
    }

    public startAvalancheBetAnimation(
        deleteMap: boolean[],
        // eslint-disable-next-line no-unused-vars
        hasHighSymbols: boolean = false
    ): gsap.core.Timeline {
        return gsap.timeline();
    }

    public stopAvalancheBetAnimation(): gsap.core.Timeline {
        return gsap.timeline();
    }

    // eslint-disable-next-line no-unused-vars
    public getScatterAnimation(): gsap.core.Tween | gsap.core.Timeline {
        return gsap.to({}, {});
    }

    // eslint-disable-next-line no-unused-vars
    public stopScatterAnimation(scatterCounter: number): gsap.core.Tween | gsap.core.Timeline {
        return gsap.to({}, {});
    }

    public clearCurrentSymbols(): void {
        this.currentSymbols = [];
    }

    // eslint-disable-next-line no-unused-vars
    public animateWinnings(winningArr: boolean[]): gsap.core.Timeline {
        return gsap.timeline();
    }

    public updateCurrentSymbols(symbols: string[]): void {
        this.clearCurrentSymbols();

        this.generateInitialSymbols(symbols);
    }

    public getReelWildAnimation(): gsap.core.Timeline {
        const timeline = gsap.timeline();

        this.currentSymbols.forEach((symbol) => {
            timeline.add(symbol.getWildAnimation(), 0);
        });

        return timeline;
    }

    public getWildSymbolByPosition(symbolPosition: number): AbstractSymbol {
        return this.currentSymbols[symbolPosition];
    }

    public getSymbolAtIndex(index: number): AbstractSymbol {
        return this.currentSymbols[index];
    }

    public getShowNearWinAnimation(): gsap.core.Tween | gsap.core.Timeline {
        return this.scatterNearWin.getShowAnimation();
    }

    public getHideNearWinAnimation(): gsap.core.Tween | gsap.core.Timeline {
        return this.scatterNearWin.getHideAnimation();
    }

    public getWinningSymbols(
        winningArr: boolean[],
        // eslint-disable-next-line no-unused-vars
        winningSymbolName: string = ``
    ): AbstractSymbol[] {
        return [];
    }

    public reset(): void {
        this.currentSymbols.forEach((symbol) => symbol.reset());
    }

    public resetOnStartSpin() {}

    public handleSoundsOnLand() {}
}
